import { Observable } from 'rxjs';
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LoginSettings } from '@lyceo/homi/login/util-models';
import {
  ENVIRONMENT,
  EnvironmentModel,
} from '@lyceo/homi/shared/util-environment';
import { SKIP_BEARER_TOKEN } from '@lyceo/shared/auth/util-models';

@Injectable({
  providedIn: 'root',
})
export class LoginSettingsService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly environment: EnvironmentModel =
    inject<EnvironmentModel>(ENVIRONMENT);

  public getLoginSettings(website: string): Observable<LoginSettings> {
    const url: string = `${this.environment.homiApiUrl}/api/login/settings/${website}-${this.environment.loginDomain}`;

    const headersToSend: HttpHeaders = new HttpHeaders().set(
      'Accept',
      'application/json',
    );
    return this.http.get<LoginSettings>(url, {
      headers: headersToSend,
      context: new HttpContext().set(SKIP_BEARER_TOKEN, true),
    });
  }
}
